<template>
  <section
    class="card vertical-space"
    :class="{ 'color-primary': solid }"
  >
    <header
      class="card__header"
      :class="{ 'card__header--solid': solid }"
    >
      <h1
        v-if="titleTag === 'h1'"
        :class="titleClasses"
      >
        {{ title }}
      </h1>
      <h2
        v-else-if="titleTag === 'h2'"
        :class="titleClasses"
      >
        {{ title }}
      </h2>
    </header>

    <div class="card__content card__content--padding">
      <slot />

      <div class="card__floating">
        <slot name="floating" />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'CCard',

  props: {
    large: {
      type: Boolean
    },
    solid: {
      type: Boolean
    },
    title: {
      type: String,
      required: true
    },
    titleTag: {
      type: String,
      default: 'h2',
      validator (value) {
        return ['h1', 'h2'].indexOf(value) >= 0
      }
    },
    uppercase: {
      type: Boolean
    }
  },

  computed: {
    titleClasses () {
      return {
        card__title: true,
        'card__title--box': true,
        'card__title--large': this.large
      }
    }
  }
}
</script>
